<span style="{{uiModel.style}}">{{uiModel.labelText}}</span>
